// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaTiktok_root__codXL"};